import React, { useRef, useState } from "react";

import emailjs from "@emailjs/browser";
import styled from "styled-components";
import contactIllustration from "../assets/boba-man-shoots-a-mail-with-a-slingshot.svg";
import { useGlobaleContext } from "../context";

const ContactPage = () => {
  const { toggleHoverAnimation } = useGlobaleContext();
  // forn state
  const [isValid, setIsValid] = useState(false);

  // email state
  /**
   * pending : Still haven't sent
   * success : email sent
   * error : No email has been sent
   */
  const [emailStatus, setEmailStatus] = useState("pending");

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        `${process.env.REACT_APP_EMAIL_SERVICE_ID}`,
        `${process.env.REACT_APP_EMAIL_TEMPLATE_ID}`,
        form.current,
        `${process.env.REACT_APP_EMAIL_PUBLIC_KEY}`
      )
      .then(
        (result) => {
          setEmailStatus("success");
        },
        (error) => {
          setEmailStatus("error");
        }
      );
  };

  const checkValidity = () => {
    if (
      form.current[0].validity.valid &&
      form.current[1].validity.valid &&
      form.current[2].validity.valid &&
      form.current[3].validity.valid
    ) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };
  return (
    <Wrapper>
      {emailStatus === "pending" ? (
        <section>
          <h1 className="font-face-js section-heading">
            <span
              className="animated--letter "
              onMouseOver={toggleHoverAnimation}
            >
              C
            </span>
            <span
              className="animated--letter "
              onMouseOver={toggleHoverAnimation}
            >
              o
            </span>
            <span
              className="animated--letter "
              onMouseOver={toggleHoverAnimation}
            >
              n
            </span>
            <span
              className="animated--letter "
              onMouseOver={toggleHoverAnimation}
            >
              t
            </span>
            <span
              className="animated--letter "
              onMouseOver={toggleHoverAnimation}
            >
              a
            </span>
            <span
              className="animated--letter "
              onMouseOver={toggleHoverAnimation}
            >
              c
            </span>
            <span
              className="animated--letter "
              onMouseOver={toggleHoverAnimation}
            >
              t
            </span>
            &nbsp;
            <span
              className="animated--letter "
              onMouseOver={toggleHoverAnimation}
            >
              m
            </span>
            <span
              className="animated--letter "
              onMouseOver={toggleHoverAnimation}
            >
              e
            </span>
          </h1>
          <p>
            At the moment, I&apos;m seeking new career opportunities as a Web
            developer. So feel free to get in touch, my inbox is always open.
            Whether you just have a question or want to say hi, I&rsquo;ll try my best
            to get back to you!
          </p>

          <form ref={form} onSubmit={sendEmail}>
            <div className="input-group">
              <input
                type="text"
                name="name"
                required
                placeholder="Your name"
                onChange={() => checkValidity()}
              />
              <label className="font-face-js " htmlFor="name">
                My name is
              </label>
            </div>

            <div className="input-group">
              <input
                type="email"
                name="email"
                placeholder="Your@email.com"
                required
                onChange={() => checkValidity()}
              />
              <label className="font-face-js">Reach me at</label>
            </div>

            <div className="input-group">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                required
                onChange={() => checkValidity()}
              />
              <label className="font-face-js" htmlFor="subject">
                Subject
              </label>
            </div>

            <div className="input-group message">
              <textarea
                name="message"
                placeholder="Start typing here..."
                required
                onChange={() => checkValidity()}
              />
              <label className="font-face-js">Message</label>
            </div>
            <button
              className={isValid ? "valid" : "disabled"}
              type="submit"
              disabled={!isValid}
            >
              <span>Send!</span>
              <span>Send!</span>
            </button>
          </form>
        </section>
      ) : (
        <section>
          <h1 className="section-heading">
            {emailStatus === "success" ? "Thank you!" : "Sorry!"}
          </h1>
          <p>
            Your message has{" "}
            {emailStatus === "success" ? (
              ""
            ) : (
              <span className="error-msg">Not</span>
            )}{" "}
            been sent successfully.
          </p>
          <button
            className="btn"
            onClick={() => {
              setEmailStatus("pending");
            }}
          >
            Send Another !
          </button>
        </section>
      )}
      <img
        className="illustration"
        src={contactIllustration}
        alt="contact me Illustration"
      />
    </Wrapper>
  );
};

const Wrapper = styled.main`
  p {
    font-size: 1.5rem;
    margin-bottom: 3.6rem;
    line-height: 2.5rem;
  }
  span {
    will-change: transform;
    transition: all 0.3s ease-out;
  }

  form {
    display: grid;
    grid-template-columns: repeat(2, [col-start] 1fr [col-end]);
    grid-template-rows: repeat(4, [row-start] 1fr [row-end]);
    grid-column-gap: 4vw;
    grid-row-gap: 2vh;
    width: 100%;
  }
  .input-group {
    display: flex;
    flex-direction: column-reverse;
  }

  .message {
    grid-column: col-start 2 / col-end 2;
    grid-row: row-start 1 / row-end 4;
    align-self: start;
    height: 100%;
  }
  label {
    font-size: 1.5rem;
    line-height: 3rem;
    letter-spacing: var(--spacing);
    font-weight: 400;
    color: var(--clr-grey-3);
  }
  input:valid ~ label,
  textarea:not(:placeholder-shown) ~ label {
    color: var(--clr-grey-8) !important;
  }

  input:invalid:not(:focus):not(:placeholder-shown) ~ label {
    color: var(--clr-red-light) !important;
  }
  input::placeholder,
  textarea::placeholder {
    color: var(--clr-grey-9);
  }

  input,
  textarea {
    outline: none;
    border: none;
    height: 100%;
  }
  input,
  textarea,
  button[type="submit"] {
    font-size: 2rem;
    padding: 1rem;
    padding-left: 0;
  }

  textarea {
    height: 100%;
  }

  button[type="submit"] {
    padding: 0;
    align-self: end;

    width: 40%;
    height: 64px;

    background: none;
    border: 2px solid;
    border-radius: var(--border-radius);
    transition: border-radius 300ms ease-out;

    text-decoration: none;
    overflow: hidden;
    background: none;
    position: relative;

    @media (max-width: 900px) {
      width: 20vw;
    }
  }
  button span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 60px;
    letter-spacing: 2px;
  }
  .disabled {
    border-color: var(--clr-grey-10);
    color: var(--clr-grey-9);
    span {
      color: var(--clr-grey-9) !important;
      background: none !important;
    }
  }

  .valid {
    border-color: var(--colors-accent-400);
    color: var(--colors-accent-400);
    transition: var(--transition);
    cursor: alias;
    @media (prefers-reduced-motion: no-preference) {
      span:nth-child(1) {
        background-color: var(--colors-accent-400);
        color: var(--colors-white);
        &:hover ~ span {
          clip-path: polygon(100% 0, 100% 0%, 100% 100%, 100% 100%, 100% 52%);
        }
      }
      span:nth-child(2) {
        background-color: var(--colors-white);
        color: var(--clr-grey-3);
        transition: 0.5s;
        clip-path: polygon(61% 0, 100% 0%, 100% 100%, 60% 100%, 45% 52%);
        &:hover {
          clip-path: polygon(0% 0, 100% 0%, 100% 100%, 0% 100%, 0% 100%);
        }
      }
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .valid:hover {
      color: var(--colors-white) !important;
      background-color: var(--colors-accent-300) !important;
    }
  }

  .valid:hover {
    border-radius: 0px;
  }
  button:active {
    transform: scale(0.9);
  }

  .error-msg {
    color: var(--clr-red-light);
    text-transform: capitalize;
    text-decoration: underline;
  }

  @media (max-width: 900px) {
    form {
      grid-template-columns: [col-start] 1fr [col-end];
      grid-template-rows: repeat(5, [row-start] 1fr [row-end]);
      gap: 0;
    }
    .message {
      grid-column: -1 / 1;
      grid-row: row-start 4 / row-end 4;
    }
    label {
      font-size: 2rem;
    }
  }

  @media (max-width: 635px) {
    section {
      padding: 0 3rem !important;
      margin: 2vh 0 !important;
      align-items: center;
    }
    button {
      width: 30vw !important;
    }
  }
`;

export default ContactPage;
